// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoScreenMobile_root__3BRUO","title":"InfoScreenMobile_title__WV3zG","body":"InfoScreenMobile_body__2Wbqu","item":"InfoScreenMobile_item__2pfEi"};